import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "Image Recognition",
        description: "Identify objects, people, and scenes in images with high precision.",
        imgUrl: "./img/services/computer-vision/image-recognition.jpg",
    },
    {
        title: "Facial Recognition",
        description: "Enable secure access control and personalized experiences using facial recognition.",
        imgUrl: "./img/services/computer-vision/facial-recognition.jpg",
    },
    {
        title: "Object Detection",
        description: "Detect and classify objects in real-time for applications like self-driving cars.",
        imgUrl: "./img/services/computer-vision/object-detection.jpg",
    },
    {
        title: "OCR (Optical Character Recognition)",
        description: "Extract text from images and scanned documents for digitization.",
        imgUrl: "./img/services/computer-vision/ocr.png",
    },
    {
        title: "Video Analytics",
        description: "Analyze video feeds to track movement, detect anomalies, and improve surveillance.",
        imgUrl: "./img/services/computer-vision/video-analytics.jpg",
    },
    {
        title: "Augmented Reality",
        description: "Integrate computer vision into AR applications for immersive user experiences.",
        imgUrl: "./img/services/computer-vision/augmented-reality.jpg",
    },
];


const ComputerVision = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Computer Vision", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Computer Vision Solutions" description="Harness the power of AI to process and analyze visual data, enabling innovative solutions across industries." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is Computer Vision?</h2>
                            <p>
                                Computer Vision uses AI and machine learning to enable systems to understand and interpret visual information from the world around them. It powers applications in diverse fields such as healthcare, automotive, and retail.
                            </p>
                            <img
                                src="./img/services/compuuter-vision.jpg"
                                alt="Computer Vision"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Computer Vision</h2>
                            <ul>
                                <li>Automate tedious visual tasks, improving efficiency.</li>
                                <li>Enhance security with advanced monitoring capabilities.</li>
                                <li>Improve customer experiences with personalized recommendations.</li>
                                <li>Accelerate innovation in industries like healthcare and retail.</li>
                                <li>Extract valuable insights from visual data.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Explore Computer Vision for Your Business</h2>
                            <p>
                                Partner with us to develop state-of-the-art computer vision solutions. <br />
                                Contact us at <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>.
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default ComputerVision;
